export default {"src":"/_next/static/media/adu.1132506e.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};